import { render, staticRenderFns } from "./DefaultWrapper.vue?vue&type=template&id=ea37eaaa&"
import script from "./DefaultWrapper.vue?vue&type=script&lang=js&"
export * from "./DefaultWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea37eaaa')) {
      api.createRecord('ea37eaaa', component.options)
    } else {
      api.reload('ea37eaaa', component.options)
    }
    module.hot.accept("./DefaultWrapper.vue?vue&type=template&id=ea37eaaa&", function () {
      api.rerender('ea37eaaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ContentHeader/DefaultWrapper.vue"
export default component.exports